import React from 'react'
import { Provider } from 'react-redux'
import { useDragLayer } from 'react-dnd'
import { DndProvider, MouseTransition, TouchTransition, Preview } from 'react-dnd-multi-backend'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { PersistGate } from 'redux-persist/integration/react'
import { IntlProvider } from 'components/Intl'
import KanBo from './KanBo'
import ReduxRouterHelper from './ReduxRouterHelper'
import Routes from 'routes'
import { ScreenSizeProvider } from 'components/ScreenSize'
import HistoryContext from './HistoryContext'
import { Router } from 'react-router'

const HTML5toTouch = {
  backends: [
    {
      backend: HTML5Backend,
      transition: MouseTransition
    },
    {
      backend: TouchBackend,
      options: { delay: 500 },
      preview: true,
      transition: TouchTransition,
    }
  ]
}

const MyPreview = () => {
  const collectedProps = useDragLayer((monitor) => {
    return {
      currentOffset: monitor.getClientOffset(),
    }
  })

  const currentOffset = collectedProps.currentOffset || { x: 0, y: 0 }

  return (
    <div
      style={{
        position: 'fixed',
        pointerEvents: 'none',
        top: -30,
        left: -30,
        borderRadius: 60,
        backgroundColor: '#666',
        width: '60px',
        height: '60px',
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 8px -4px rgba(0, 0, 0, 0.5)',
        transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
        opacity: 0.75,
        zIndex: 99999
      }}
    />
  )
};

const App = ({
  store,
  persistor,
  history,
}) => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <IntlProvider>
          <DndProvider options={HTML5toTouch}>
            <Preview>
              <MyPreview />
            </Preview>
            <HistoryContext.Provider value={history}>
              <ScreenSizeProvider>
                <Router history={history}>
                  <ReduxRouterHelper history={history} />
                  <KanBo>
                    <Routes />
                  </KanBo>
                </Router>
              </ScreenSizeProvider>
            </HistoryContext.Provider>
          </DndProvider>
        </IntlProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
